<template>
  <div class="home">
    <HeroSection />
    <CompanySection />
    <FeaturesSection />
    <ModelSection />
    <TestimonialsSection />
    <CtaSection />
  </div>
</template>

<script>
import HeroSection from '@/components/sections/HeroSection.vue'
import FeaturesSection from '@/components/sections/FeaturesSection.vue'
import ModelSection from '@/components/sections/ModelSection.vue'
import TestimonialsSection from '@/components/sections/TestimonialsSection.vue'
import CtaSection from '@/components/sections/CtaSection.vue'
import CompanySection from '@/components/sections/CompanySection.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    FeaturesSection,
    ModelSection,
    TestimonialsSection,
    CtaSection,
    CompanySection
  }
}
</script> 